import React from "react";
import "./toast.scss"; // Adjust the path as needed
import { Modal, ToastMessage, Badge } from "@forge/common";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../../common/store/combinedReducer";
import { hideToast } from "../../../store/model/model.action";

// Use a proper PascalCase type name and export if needed elsewhere
interface ToastModal {
  open: boolean;
  type: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  subtitle?: string;
  content?: string;
  lifetime?: number;
}

function ToastMessageComponent(): JSX.Element {
  const dispatch = useDispatch();
  // Safely select toastModal; some tests mount App with a store that omits modalReducer
  const toastModal = (useSelector(
    (state: any) => state?.modalReducer?.toastModal
  ) as Partial<ToastModal> | undefined) ?? { open: false };

  const selectBadge = () => {
  switch(toastModal?.type) { 
      case "success":
        return <Badge type="success">Success</Badge>;
      case "error":
        return <Badge type="error">Error</Badge>;
      case "warning":
        return <Badge type="warning">Warning</Badge>;
      case "info":
        return <Badge type="progress">Information</Badge>;
      default:
        return <Badge type="progress">Information</Badge>;
    }
  }

  const args = {
    id: "toast-message",
    type: selectBadge(),
    title: toastModal?.title ?? undefined,
    subtitle: toastModal?.subtitle ?? undefined,
    content: toastModal?.content ?? undefined,
    lifetime: toastModal?.lifetime ?? 10000,
    showClose: true,
    showDismiss: false,
    onRemove: () => dispatch(hideToast()),
  };

  return (
    <React.Fragment>
      {toastModal?.open ? (
        <div
          className="w-full h-full fixed top-0 left-0 z-50 flex justify-center items-start bg-[rgba(0,0,0,0.4)]"
          onClick={(e) => e.stopPropagation()}
        >
          <Modal
            backdrop={false}
            className="model-toast-Popup !bg-transparent !shadow-none !overflow-hidden !block"
            onModalClose={() => dispatch(hideToast())}
          >
            <ToastMessage {...args} />
          </Modal>
        </div>
      ) : null}
    </React.Fragment>
  );
}

export default ToastMessageComponent;